var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F2F2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.4999L15 17.4999L19.5 12.9999M24 15.9999C24 20.9083 18.646 24.4783 16.698 25.6147C16.4766 25.7439 16.3659 25.8085 16.2097 25.842C16.0884 25.868 15.9116 25.868 15.7903 25.842C15.6341 25.8085 15.5234 25.7439 15.302 25.6147C13.354 24.4783 8 20.9083 8 15.9999V11.2175C8 10.418 8 10.0182 8.13076 9.67457C8.24627 9.37101 8.43398 9.10015 8.67766 8.8854C8.9535 8.64231 9.3278 8.50195 10.0764 8.22122L15.4382 6.21054C15.6461 6.13258 15.75 6.0936 15.857 6.07815C15.9518 6.06444 16.0482 6.06444 16.143 6.07815C16.25 6.0936 16.3539 6.13258 16.5618 6.21054L21.9236 8.22122C22.6722 8.50195 23.0465 8.64231 23.3223 8.8854C23.566 9.10015 23.7537 9.37101 23.8692 9.67457C24 10.0182 24 10.418 24 11.2175V15.9999Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.276a86dbaf2eaebdb70cabbe7d6dee2a.svg";
export { ForwardRef as ReactComponent };